// @flow
import * as React from 'react'

import './ImageHeroContent.scss'

type Props = {
  title?: string,
  subtitle?: string,
  body?: string,
  actions?: React.Node,
  children?: React.Node,
}

export default class ImageHero extends React.Component<Props> {
  render = () => {
    return (
      <div className="ImageHeroContent">
        {this.renderTitleMaybe()}
        {this.renderSubtitleMaybe()}
        {this.renderBodyMaybe()}
        {this.renderActionsMaybe()}
        {this.props.children}
      </div>
    )
  }

  renderTitleMaybe = () => {
    if (!this.props.title) return null

    return <h1 className="ImageHeroContent-title">{this.props.title}</h1>
  }

  renderSubtitleMaybe = () => {
    if (!this.props.subtitle) return null

    return <div className="ImageHeroContent-subtitle">{this.props.subtitle}</div>
  }

  renderBodyMaybe = () => {
    if (!this.props.body) return null

    return <div className="ImageHeroContent-body">{this.props.body}</div>
  }

  renderActionsMaybe = () => {
    if (!this.props.actions) return null

    return <div className="ImageHeroContent-actions">{this.props.actions}</div>
  }
}
